<template>
  <div class="ReactModalPortal order-datetime-modal">
    <div class="ReactModal__Overlay ReactModal__Overlay--after-open " class-open="ReactModal__Overlay--after-open"
         aria-modal="true">
      <div
        class="ReactModal__Content overlay xs-full-height xs-full-width xs-mb-0 xs-flex xs-items-center ReactModal__Content--after-open"
        class-open="ReactModal__Content--after-open" tabindex="-1" aria-label="DelayedOrderModal">
        <div class="" style="width: 100%; height: 100%;">
          <div class="xs-pt-60 xs-px-40 xs-text-white pb-20">
            <p class="xs-mb-20 text-center t24" v-if="message" v-html="message"></p>
            <p class="xs-mb-20 text-center t24 font-sharp-sans" v-if="isShowTimePicking">{{$t('what_time_would_you_like_your_order')}} </p>
          </div>
          <button type="button" class="icon-close--white xs-p-20 xs-absolute xs-r-20 xs-t-10 close-order-datetime" @click="$emit('close')"></button>
          <div class="text-center" v-if="isShowTimePicking">
            <div class="col-md-3 ">
            </div>
            <div class="col-md-3  col-xs-12 ">
              <i class="fa fa-calendar xs-mr-5 fa-o-before-20" style="width: 20px;height: 20px"> </i>
              <select class="select-popup-date-time t22" v-model="choiceDay">
                <option v-for="(item, i) in dataDate" :key="i" :value="item.value" class="dropdown-item">
                  {{ item.label }}
                </option>
              </select>
            </div>

            <div class="col-md-3 col-xs-12 ">
              <i class="fa fa-clock-o xs-mr-5 fa-o-before-20" style="width: 20px;height: 20px"></i>
              <select class="select-popup-date-time t22" v-model="choiceHour">
                <option v-for="(item, i) in dataTime" :key="i" :value="item.value" class="dropdown-item">
                  {{ item.label }}
                </option>
              </select>
            </div>
            <div class=" pt-100 action-save-date-time">
              <button style="width: 45%;margin: auto; background: #e9ebee;" type="button" v-if="isShowCTA" 
                class="button button--primary xs-text-center save-date-time" @click="setTime()">
                {{$t('modal.set_order_time')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import moment from 'moment-timezone'
import {mapGetters} from 'vuex'
import ModalActionError from './ModalActionError'

export default {
  props: ['outletId', 'outletDataZip', 'outletDataLocalization', 'orderType', 'hideASAP', 'message', 'gotoFindHut', 'reOrder'],
  comments: {},
  beforeCreate: function () {
    const body = document.getElementsByTagName('body')[0]
    body.classList.add('modal-asap')
  },
  beforeDestroy: function () {
    const body = document.getElementsByTagName('body')[0]
    body.classList.remove('modal-asap')
  },
  created () {
    this.callEventBus(this.$const.EVENT_BUS.LOADING, true)
  },
  mounted () {
    let data = {
      'id': 'delivery-time',
      'name': 'delivery-time',
      'type': 'tool',
      'placement': 'floating',
      'items': [
        {
          'id': 'delivery-time-1',
          'type': 'tool',
          'position': '1'
        }
      ],
      'assets': {
        'tools': [
          {
            'id': 'delivery-time-1',
            'type': 'selector',
            'name': 'delivery-time',
            'attributes': {
              'function': 'select-delivery-slot'
            }
          }
        ]
      }
    }
    this.eventTrackingModuleLoad(data)
    this.$disposition.init(this)
    this.init()
  },
  data () {
    return {
      selected: null,
      isShowCTA: true,
      isShowTimePicking: true,
      timezone: null,
      choiceDay: '',
      choiceHour: '',
      dataDate: [],
      dataTime: [],
      objTime: null
    }
  },
  watch: {
    choiceDay () {
      if (this.choiceDay) {
        const obj = this.objTime[this.choiceDay]
        this.dataTime = this.checkASAP(obj, this.choiceDay, true)
        const now = moment.tz(new Date(), obj.timezone)
        if (now.format('YYYY-MM-DD') === this.choiceDay && this.dataTime.length === 0) {
          this.dataDate = this.dataDate.filter(item => item.value !== this.choiceDay)
          this.choiceDay = this.getValueFromAttr(this.dataDate, '0.value')
          return
        }
        const collectionTime = this.$disposition.getByKey(this, 'collectionTime', {}) || {}
        const time = this.choiceHour || (collectionTime && collectionTime.pickedHours)
        const check = time ? this.dataTime.filter(item => item.value === time) : []
        this.choiceHour = check && check.length > 0 ? time : this.getValueFromAttr(this.dataTime, '0.value')
        if (this.objTime[this.choiceDay]) {
          this.timezone = this.objTime[this.choiceDay].timezone
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isValidOrderTime: 'isValidOrderTime'
    })
  },
  methods: {
    /**
       * Init data after load page
       * */
    init () {
      let id = 0
      if (typeof this.outletId !== 'undefined' && this.outletId) {
        id = this.outletId
      } else if (!this.empty(this.$disposition.getByKey(this, 'outletId', ''))) {
        id = this.$disposition.getByKey(this, 'outletId', '')
      }
      var vm = this
      let orderType = vm.orderType || this.$disposition.getByKey(vm, 'orderType', 'D').charAt(0)
      this.axios.apiOutlet.getOutletOpeningHours({outletId: id, order_type: orderType.charAt(0)}, function (response) {
        const items = response.data.data.items
        if (!vm.empty(items)) {
          vm.dataDate = vm.generateDateOrder(items)
          vm.objTime = vm.generateTimeOrder(items)
          const collectionTime = vm.$disposition.getByKey(vm, 'collectionTime', {}) || {}
          vm.choiceDay = collectionTime.pickedDay || vm.getValueFromAttr(vm.dataDate, '0.value')
        }
        vm.callEventBus(vm.$const.EVENT_BUS.LOADING, false)
      }, function (error) {
        vm.callEventBus(vm.$const.EVENT_BUS.LOADING, false)

        if (!vm._.isEmpty(vm._.get(error, 'error.message'))) {
          const errCode = vm._.get(error, 'error.code')
          const errMsg = vm.getMessageFromGms(error)

          if (vm.$const.MESSAGES_CODE.STOP_DELIVERY_TOTAL.indexOf(errCode) >= 0) {
            vm.$modal.show(ModalActionError, {
              message: errMsg
            })
          } else {
            vm.isShowCTA = false
            vm.isShowTimePicking = false
            vm.message = errMsg
          }
        }
      })
    },
    /**
       * Set Collection time and redirect page
       * */
    setTime: function () {
      var timepicker = {'pickedDay': this.choiceDay, 'pickedHours': this.choiceHour}
      let data = this.$disposition.get(this)
      data.collectionTime = timepicker
      data.collectionTimeText = this.choiceDay + ' ' + this.choiceHour
      let time = this.choiceHour.split(' - ')
      if (time.length > 1) {
        time = time[1]
      } else if (time.length > 0) {
        time = time[0]
      }
      data.collectionTimeValue = this.choiceDay + ' ' + time
      data.timezone = this.timezone
      data.advanceOrder = 1
      if (this.choiceHour === 'ASAP') {
        data.advanceOrder = 0
      }
      this.$disposition.set(this, data)
      this.$emit('close')
      // call api to update order time
      this.$cart.updateOrderTime(this, {'order_time': this.getTimePickerDate(this)})
      this.$root.$emit('collectionTimeUpdate')
      if (this.outletDataZip) {
        this.$root.$emit('onCheckValidOutletZipCode', this.outletDataZip)
      }
      if (this.outletDataLocalization && this.reOrder) {
        this.$root.$emit('onCheckValidOutletReOrder', this.outletDataLocalization)
      } else if (this.outletDataLocalization) {
        this.$root.$emit('onCheckValidOutlet', this.outletDataLocalization)
      }

      this.callEventBus(this.$const.EVENT_BUS.LOAD_CATEGORY, true)
      if (this.gotoFindHut) {
        this.$router.push({ 'name': 'huts', 'params': { 'outlet': this.outletId } })
      }
    }
  }
}
</script>
<style scoped>
  select {
    border: none;
    background: transparent;
    /*background-color: blue;*/
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding-top: 0px;
    background-size: 20px;
    color: #ffffff !important;
  }

  select.select-popup-date-time .dropdown-item {
    font-size: 15px !important;
  }

  .select-popup-date-time {
    border: 0;
    border-bottom: 1px solid #999;
    background: none;
    color: #fff !important;
    width: 79%;
  }

  .fa {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/OrderASAP.vue